import { tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const Count = styled.span`
  color: ${tokens.ALIAS_TEXT_COLORS.text_light};
  flex-shrink: 0;
  min-width: 0;
`;

const Title = styled.span`
  color: inherit;
  flex-shrink: 1;
  min-width: 0;
  text-align: left;
  ${tokens.truncateText()};
`;

const SideBarItemContainer = styled.li`
  display: flex;
  flex-direction: column;
`;

const SideBarButton = styled.button(
  ({ selected }: { selected: boolean }) => `
  color: ${tokens.color.text_default};

  cursor: pointer;

  min-height: ${tokens.spacer.x4};

  display: flex;
  flex-direction: row;
  align-self: stretch;
  align-items: center;
  justify-content: space-between;
  gap: ${tokens.spacer.x1};
  padding: 6px ${tokens.spacer.x1};

  border-radius: ${tokens.radius.m};
  border: none;
  background: none;

  &:focus {
    outline: none;
    ${tokens.focus()};
  }

  ${tokens.transition('background-color')};
  ${tokens.transition('box-shadow')};

  ${tokens.text('body2')};
  
  text-decoration: none;

  &:not(:focus-visible) {
    outline: none;
    box-shadow: none;
  }

  &:hover {
    background: ${tokens.color.neutral_100};
    color: inherit;
  }

  &:active {
      background: ${tokens.color.bg_active};
      color: inherit;
  }

  &:focus {
    color: inherit;
  }

  ${
    selected &&
    `
    background-color: ${tokens.BRAND_COLORS.cobalt_200};
    color: ${tokens.color.secondary_cta};

    & ${Title} {
      ${tokens.text('subtitle2')};
    }

    & ${Count} {
        color: ${tokens.color.secondary_cta};
      }

    &:focus, &:hover {
        color: ${tokens.color.secondary_cta};
    }
  `
  }
`,
);

export interface SideBarItemProps {
  title: string;
  count: number;
  isSelected: boolean;
  onSelected: () => void;
}

export const SideBarItem = ({
  title,
  count,
  isSelected,
  onSelected,
}: SideBarItemProps): JSX.Element => {
  return (
    <SideBarItemContainer>
      <SideBarButton
        selected={isSelected}
        aria-label={title}
        aria-selected={isSelected}
        onClick={onSelected}
      >
        <Title>{title}</Title>
        <Count aria-label="Item count">{count}</Count>
      </SideBarButton>
    </SideBarItemContainer>
  );
};
